import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { getGaragesAsync } from '../../redux/slices/garagesSlice';
import { setNotification } from '../../redux/slices/notificationSlice';
import { useDispatch } from 'react-redux';
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import { Button } from '@mui/material';
import { filterGarages } from '../../redux/slices/garagesSlice';

const GarageTaskGrid = ({task, assignGarage}) => {

    const garages = useSelector(state => state.garages.filteredGarages);
    const loading = useSelector(state => state.garages.loading);
    const dispatch = useDispatch();
    const [showHeavy, setShowHeavy] = useState(false);
    const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 20});

    useEffect(() => {
        const getGarages = async () => {

            try{
                const response = await dispatch(getGaragesAsync({id: task.id})).unwrap();
                if(response.status == 200 || response.status == 204) {
                    dispatch(
                        setNotification({ severity: 'success', message: 'Garages retrieved.' })
                    );
                }
            }
            catch(error) {
                dispatch(
                    setNotification({ severity: 'error', message: 'Garages retrieval error: ' + error.message })
                );
            }
        }

        getGarages();
    }, []);

    const formatRefused = value => {
        return value ? 'Yes' : 'No';
    }

    const formatNetwork = value => {
        if (value == 'AA SUPPLIER NETWORK') return 'SUPPLIER';
        if (value == 'TRUCK NETWORK') return 'TRUCK';
    }

    const columns = [
        {
            field: 'resourceId',
            headerName: 'ID',
            description: 'Garage ID',
            flex: 0.3,
            minWidth: 100,
        },
        {
            field: 'name',
            headerName: 'Garage Name',
            description: 'Garage Name',
            flex: 0.5,
            minWidth: 150,
        },
        {
            field: 'phoneNumber',
            headerName: 'Phone',
            description: 'Phone',
            flex: 0.5,
        },
        {
            field: 'openTaskCount',
            headerName: 'Task Count',
            description: 'Open Task Count',
            flex: 0.5,
        },
        {
            field: 'hasRefusedTask',
            headerName: 'Refused Before',
            description: 'Has refused task before',
            flex: 0.5,
            valueGetter: value => formatRefused(value),
        },
        {
            field: 'distanceFromTask',
            headerName: 'Distance (Km)',
            description: 'Garage ID',
            flex: 0.5,
            minWidth: 150,
        },
        {
            field: 'networkName',
            headerName: 'Network',
            description: 'Network Name',
            flex: 0.5,
            minWidth: 150,
            valueGetter: value => formatNetwork(value),
        },
    ];

    const handleRowClick = (params) => {
        assignGarage(params.row.resourceId); 
    };

    const handleFilterGarages = () => {
        dispatch(filterGarages(showHeavy));
        setShowHeavy(!showHeavy);
    }

    return (
        <>
            { 
            <>
            <Button onClick={handleFilterGarages} sx={{p: '0 15px', mb: 1, mt: 1, background: 'var(--template-palette-action-selected)'}}>{!showHeavy? 'Show Truck Network Results' : 'Hide Truck Network Results'}</Button>
            
            <DataGrid
                sx={{ width: 1, height: 'auto' }}
                rows={garages || {}}
                loading={loading}
                getRowId={row => row.resourceId}
                columns={columns}
                rowSelectionModel={[task?.assignedGarageId]}
                onRowClick={handleRowClick}
                getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
                pagination
                paginationModel= {paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10, 20, 50]}
                disableColumnResize
                density="compact"
                slotProps={{
                filterPanel: {
                    filterFormProps: {
                    logicOperatorInputProps: {
                        variant: "outlined",
                        size: "small",
                    },
                    columnInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                    },
                    operatorInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                    },
                    valueInputProps: {
                        InputComponentProps: {
                        variant: "outlined",
                        size: "small",
                        },
                    },
                    },
                },
                }}
            />
            </>}
        </>
    );
}

export default GarageTaskGrid;